// D-1010 (ひろ 2026-10-08「ホームも戻ると同じに」「シンプルなアイコンに合わせたい」):
//   戻る(← / ‹)とホーム(⌂)の字をやめ、線のアイコンにする。全画面で同じ太さ・同じ大きさ。
// 出典: Lucide (https://lucide.dev) v0.460 — ISC License (Copyright (c) Lucide Contributors)。arrow-big-left / house。
//   ★報告種別アイコン(src/components/icons/alertSilhouettes.jsx, D-308)と同じ流儀:
//     lucide-react は入れず、パスをリテラルで持つ。viewBox 24 / stroke 2 / currentColor(色はボタンの文字色を継ぐ)。
//   ★新しいアイコンは Lucide から取る(ひろ 2026-10-08)。パスをコピーし、下の NavSvg(24 / stroke 2 / round / currentColor)で包む。
//   ★shared は shared しか import できない(eslint-plugin-boundaries)ので、components/icons の Svg は使わずここに持つ。
import React from 'react'

/** 戻る・ホームのアイコンの一辺(px)。48px の箱(backButton.js)の中で 26px。 */
export const NAV_ICON_PX = 26

/** 線のアイコンの共通の枠。UiIcons.jsx(D-1011)もこれで包む。 */
export function NavSvg({ name, size = NAV_ICON_PX, className, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      // 指は常にボタン本体に当たる(e.target / elementFromPoint が svg・path にならない。D-840 e2e が中心の要素を見る)
      style={{ pointerEvents: 'none' }}
      data-icon={name}
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  )
}

/** 戻る — lucide v0.460: arrow-big-left(ひろ 2026-10-08 の選択)。差し替えるときはここだけ直す。 */
export function BackIcon(props) {
  return (
    <NavSvg name="arrow-big-left" {...props}>
      <path d="M18 15h-6v4l-7-7 7-7v4h6v6z" />
    </NavSvg>
  )
}

/** ホーム — lucide: house */
export function HomeIcon(props) {
  return (
    <NavSvg name="house" {...props}>
      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
      <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </NavSvg>
  )
}

/**
 * 閉じる — lucide v0.460: x(D-1014 ひろ 2026-10-08)。字(✕ / ×)の代わり。
 *   ★戻る/ホームと同じ 48×48 の箱(shared/ui/CloseButton.jsx)に入れて使う。大きさも同じ NAV_ICON_PX。
 */
export function CloseIcon(props) {
  return (
    <NavSvg name="x" {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </NavSvg>
  )
}
